module.exports = __webpack_public_path__ + "static/media/[Professor_Teas]2014-04-21-2.c4543b70.md";